import _FormRecommendation from './FormRecommendation';
import _FormApplication from './FormApplication';
import _FormSubscribe from './FormSubscribe';

export const FormRecommendation = _FormRecommendation;
export const FormApplication = _FormApplication;
export const FormSubscribe = _FormSubscribe;



// WEBPACK FOOTER //
// ./src/components/Form/index.js